import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ERR_BAD_REQUEST } from '@app/contstants/http-codes';
import { ServerError } from '@app/error/ServerError';
import { IApplicationAttachment } from '@entities/application/IApplicationTask';

// @ts-ignore
export const fetchData = async (data: {
  fileData: string;
  filename: string;
}): Promise<IApplicationAttachment> => {
  try {
    const attachment: { data: IApplicationAttachment } = await api.post(
      `${PANEl_BASE_URL}/application/application-files/`,
      {
        file_data: data.fileData,
        filename: data.filename,
      }
    );

    return attachment.data;
  } catch (e: any) {
    if (e.status === ERR_BAD_REQUEST) {
      throw new ServerError(e.response.data.error);
    }
  }
};

export const useUploadApplicationImage = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchData,
    onError: error => errorHandler(error),
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
